/* eslint-disable @next/next/no-img-element */
import NavBar from "../../../components/chuyen-gia/navBar";
import http from "../../../utilities/http";
import {isEmpty , isUndefined} from "lodash";
import TongQuan from "components/chuyen-gia/content/TongQuan";
import BaiViet from "components/chuyen-gia/content/BaiViet";
import HinhAnh from "components/chuyen-gia/content/HinhAnh";
import DanhGia from "components/chuyen-gia/content/DanhGia";
import Coupon from "components/chuyen-gia/content/Coupon";
import ThaoLuan from "components/chuyen-gia/content/ThaoLuan";
import GioiThieu from "components/chuyen-gia/content/GioiThieu";
import Profile from 'components/chuyen-gia/content/Profile';
import {useRouter} from 'next/router';
import LuuTru from "components/tai-khoan/ho-so/so-luu-tru";
import {useState} from "react";
import Head from "next/head";

export default function Index({ profession, proInf, vouchers, pinArticles, pinPhoto,pinThread, pinReview }) {
    const router = useRouter();
    const currentTab = router.query?.t || 'tong-quan';
    const [pins, setPin] = useState({
        articles: {
            data: pinArticles?.data,
            total: pinArticles?.meta?.pagination?.total
        }, photos: {
            data: pinPhoto?.data,
            total: pinPhoto?.meta?.pagination?.total
        }, thread: {
            data: pinThread?.data,
            total: pinThread?.meta?.pagination?.total
        }, reviews: {
            data: pinReview?.data,
            total: pinReview?.meta?.pagination?.total
        },
    });


    const tabContent = {
        'tong-quan': (<TongQuan profession={profession} />),
        'bai-viet': (<BaiViet profession={profession} />),
        'hinh-anh': (<BaiViet profession={profession} activeTab={`kho-anh`}/>),
        'danh-gia': (<DanhGia profession={profession}/>),
        'coupon':   (<Coupon profession={proInf} vouchers={vouchers}/>),
        'so-luu-tru': (<LuuTru pins={pins} wishlist={[]} rootPath={`/thanh-vien/u/${profession.id}?t=so-luu-tru`} isPro={true}></LuuTru>),
        'gioi-thieu': (<GioiThieu proInf={proInf}/>),
    };
    const getChildClass = function () {
        switch (currentTab) {
        case "coupon": {
            return "expert-voucher";
        }
        case "thao-luan": {
            return "expert-review";
        }
        // case "so-luu-tru" : {
        //     return "expert-save";
        // }
        case "gioi-thieu": {
            return "expert-introduce";
        }
        case "danh-gia": {
            return "expert-review";
        }
        default: {
            return "";
        }
        }
    };

    return (
        <>
            <Head>
                <title>{(proInf.is_professional ? 'Chuyên gia ' : 'Thành viên ')} {proInf?.display_name}</title>
                <meta property="og:title" content={(proInf.is_professional ? 'Chuyên gia ' : 'Thành viên ') + proInf?.display_name} key="title" />
                {/* <meta property="description" content={article.seo.description} key="description" />
                <meta property="og:description" content={article.seo.description} key="og:description" /> */}
                {/* <meta property="og:keywords" content={article.seo.keywords} key="keywords" /> */}
            </Head>
            <section className="main main-with-one-menu main--expert">
                <NavBar 
                    proInf={proInf}
                    profession={profession}
                    voucherCount={vouchers?.meta?.pagination?.total || 0}
                    screen={"pc-only"} />
                <div className="wrap expert__wrap">
                    <Profile proInf={proInf} profession={profession} />
                    <div className={"expert__wrap-content " + getChildClass()}>
                        <NavBar 
                            proInf={proInf}
                            profession={profession}
                            voucherCount={vouchers?.meta?.pagination?.total || 0}
                            screen={"sp-only"} />
                        {tabContent[currentTab]}
                    </div>
                </div>
            </section>
        </>
    );
};
export const getStaticPaths = async ({}) => {
    const listTab = ["bai-viet", "coupon", "danh-gia", "gioi-thieu", "hinh-anh", "so-luu-tru", "thao-luan", "tong-quan"];

    const res = await http("community/professional", {}, {token: 'default'}, 'v2');
    const path = [];

    if (!isEmpty(res?.data)) {
        res?.data?.forEach(x => {
            path.push({
                params: {
                    slug: `${x.id}`
                }
            });
        });
    };

    return {
        paths: path,
        fallback: 'blocking'
    };
};
export const getStaticProps = async ({params}) => {
    const res = await Promise.all([
        http(`community/professional/${params.slug}`, null, {token: 'default'}, 'v2'),
        Promise.resolve(),
        Promise.resolve(),
        Promise.resolve(),
        Promise.resolve(),
        Promise.resolve(),
        http(`community/professional/${params.slug}/vouchers?page=1&per_page=6`,null,{ token: 'default' }, 'v2' ),

        http(`community/professional/${params.slug}/pins/article?page=1`,null,{ token: 'default' }, 'v2' ),
        http(`community/professional/${params.slug}/pins/photo?page=1`,null,{ token: 'default' }, 'v2' ),
        http(`community/professional/${params.slug}/pins/thread?page=1`,null,{ token: 'default' }, 'v2' ),
        http(`community/professional/${params.slug}/pins/review?page=1`,null,{ token: 'default' }, 'v2' ),
    ]);
    return {
        props: {
            key: params.slug,
            profession: { id: params.slug },
            proInf: res[0]?.data || [],
            vouchers: res[6],

            pinArticles: res[7],
            pinPhoto: res[8],
            pinThread: res[9],
            pinReview: res[10],

        },
        revalidate: 30,
    };
};
